import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 10l.01 0","key":"svg-1"}],["path",{"d":"M15 10l.01 0","key":"svg-2"}],["path",{"d":"M9 15l6 0","key":"svg-3"}]]

const IconMoodEmpty = createReactComponent('outline', 'mood-empty', 'MoodEmpty', __iconNode);

export default IconMoodEmpty;